import type { GrantRole } from '../types/user.js';

// Mirrors the backend limit on `grants` per user (backend/src/users/constants.ts).
export const MAX_USER_GRANTS = 50;

export const GRANT_ROLES = ['operator', 'observer'] as const satisfies readonly GrantRole[];

// A freshly picked tag starts read-only; the operator role is an explicit step up.
export const DEFAULT_GRANT_ROLE: GrantRole = 'observer';
